import { Button, Icon } from '@chakra-ui/react'
import { Share2 as Share } from 'lucide-react'
import { useTranslation } from 'react-i18next'

interface ShareButtonProps {
  onClick: () => void
  isVisible: boolean
}

export function ShareButton({ onClick, isVisible }: ShareButtonProps) {
  const { t } = useTranslation()

  if (!isVisible) {
    return null
  }

  return (
    <Button
      aria-label="Share filtered view"
      onClick={onClick}
      height={6}
      size="sm"
      pl={2}
      py={2}
      variant="outline"
      colorPalette="blue"
      borderColor="blue.500"
      data-testid="share-filters-button"
    >
      <Icon as={Share} />
      {t('clusterConfigTable.actions.share')}
    </Button>
  )
}
